import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=332ab533&scoped=true"
import script from "./AddAccount.vue?vue&type=script&lang=js"
export * from "./AddAccount.vue?vue&type=script&lang=js"
import style0 from "./AddAccount.vue?vue&type=style&index=0&id=332ab533&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ab533",
  null
  
)

export default component.exports